<template>
    <div rel="error">
        <div v-if="showIcon" id="cancelLogo" class="col-12 centerCancel">
        </div>
        <div class=" col-12 centerCancel">
            <h2 v-if="showIcon">{{ errorTitleHtml }}</h2>
            <p>{{ errorHtml }}</p>
        </div>
        <button @click="closeErrorUp" id="btnClosePopUp" class="btnPopUp btnClose">Entendido</button>
    </div>
</template>
<script>
import setttings from '../../assets/environments/errors.json';
import constants from '../../assets/environments/constants.json';

export default {
    name: 'error',
    props: {
        numError: Number
    },
    data() {
        return {
            errorHtml: null,
            errorTitleHtml: null,
            showIcon: true,
            noIconList: [constants.dniUpOk, constants.reSendOkCode],
            codError:''
        }
    },
    mounted() {
        this.$emit('changeVeil', true, false)
        this.codError = this.numError
        if (this.numError == '' || this.numError == null) {
            this.codError = constants.unknowError
        }
        for (let i in this.noIconList) {
            if (this.noIconList[i] == this.codError) { this.showIcon = false }
        }
        this.errorTitleHtml = setttings[this.codError].titles
        this.errorHtml = setttings[this.codError].msg
    },
    methods: {
        closeErrorUp() {
            if (this.codError == constants.invalidCodeNoRetriesLeft) {
                this.$router.push({
                    name: 'secureAccess'
                })
            }
            this.$emit('closeError', false)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/errors/error.vue